// =============================================================================
// VAT money helpers (frontend).
// =============================================================================
// Catalogue prices are stored VAT-INCLUSIVE (gross) and used everywhere as the
// selling price. These helpers convert between the gross (incl. VAT) price and
// the net (excl. VAT) price for data entry/display. They mirror the backend
// split exactly (see apps/backend/.../accounting/deposit-invoicing.ts):
//   vat = round(gross × r / (1 + r))   ·   net = gross − vat
// so the "excl. VAT" figure shown here equals the taxable value on the invoice.

export const round2 = (n: number): number => Math.round((n + Number.EPSILON) * 100) / 100;

/** Net (excl. VAT) extracted from a VAT-inclusive gross amount. */
export function grossToNet(gross: number, rate: number): number {
  if (!Number.isFinite(gross) || rate <= 0) return round2(gross || 0);
  const vat = round2((gross * rate) / (1 + rate));
  return round2(gross - vat);
}

/** Gross (incl. VAT) built up from a net (excl. VAT) amount. */
export function netToGross(net: number, rate: number): number {
  if (!Number.isFinite(net) || rate <= 0) return round2(net || 0);
  return round2(net * (1 + rate));
}
